//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "source-approval-list",
  data(){
    return{
      wrapperHeight:0,
      allLoaded:false,
      configTodo:{
        title:'待审核的寻源项目',
        url:'api/source/page',
        workflowSearchBean:{},
        fixRules:{},
        inputCondition:{
          placeholder:'单号/项目名称',
          searchCondition:'key',
          rules:[{field:"sourceNum-sourceProject", option: "LIKE_ANYWHERE"}]
        },
      },
      list:[]
    }
  },
  methods:{
    getList(e,met,bol){
      this.$nextTick(()=>{
        if(bol){
          this.list = this.list.concat(e);
        }else{
          this.list = e;
        }
        if(met === 'top'){
          this.$refs.loadmore.onTopLoaded();
        }
        if(met === 'bottom'){
          this.$refs.loadmore.onBottomLoaded();
        }
      })
    },
    init: function() {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    loadTop(){
      this.$refs.header.getlist(true);
    },
    loadBottom(){
      this.$refs.header.getMore();
    },
    getWorkFlow(){
      this.$get('api/biz-object-parameters/key/sourceCreate').then(data=>{
        this.configTodo.workflowSearchBean = {
          workflowId: data.workflowType,
          searchType: '0',
        };
        this.$refs.header.getlist();
      })
    },
    goDetail(item){
      this.$router.push('/workflow/' + item.requestId + `?component=SourceItemViewComponent&orderNo=No.${item.sourceNum}`);
    }
  },
  mounted(){
    this.init();
    this.getWorkFlow();
  }
}



// WEBPACK FOOTER //
// ./src/page/sources/source-item/source-approval-list.vue